export default __webpack_public_path__ + "static/strategy_analysis_img_4-3b0fc2bc9d1b039b1b801c788c08f8e4.png";